<template>
  <base-modal
    :is-visible="isVisible"
    @hideModal="hideModal()"
    :is-editable="false"
    :is-archivable="false"
    :no-close-on-backdrop="true"
    size="xl"
  >
    <template #header>
      {{ $t('routes.FirmUpdate') }}
    </template>
    <template #body>
      <update :id-user-data="idUserData"></update>
    </template>
  </base-modal>
</template>

<script>
import BaseModal from '@/components/BaseComponents/BaseModal'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import Update from '@/components/Dashboard/Views/firm/Update'

export default {
  name: 'UpdateModal',
  components: {
    BaseModal,
    Update
  },

  props: ['idUserData'],

  computed: {
    ...mapGetters({
      isVisible: 'userdata/updateModal/isVisible',
      updated: 'userdata/update/updated'
    })
  },

  watch: {
    updated (val) {
      if (val) {
        this.fetchUserDataOptions()
        this.hideModal()
      }
    }
  },

  methods: {
    hideModal () {
      this.reset()
      this.toggleModal()
    },
    ...mapActions({
      reset: 'userdata/update/reset',
      fetchUserDataOptions: 'userdata/list/default'
    }),
    ...mapMutations({
      toggleModal: 'userdata/updateModal/toggleModal'
    })
  }
}
</script>

<style scoped>

</style>
